import { Link } from "@tanstack/react-router";
import type { RefObject } from "react";
import { cn } from "@wags/ui/ui-utils";
import {
    ChevronSmallLeftIcon as ChevronLeftIcon,
    ChevronSmallRightIcon as ChevronRightIcon,
} from "@wags/ui/product-icons.tsx";

const ARROW_CLASS =
    "flex size-9 cursor-pointer items-center justify-center rounded-nested bg-true-black/4 text-doberman-black transition-colors hover:bg-true-black/7 disabled:pointer-events-none disabled:opacity-35";

export function ReviewsScrollArrows({
    scrollRef,
    canScrollPrevious,
    canScrollNext,
}: {
    scrollRef: RefObject<HTMLDivElement | null>;
    canScrollPrevious: boolean;
    canScrollNext: boolean;
}) {
    const scrollBy = (left: number) =>
        scrollRef.current?.scrollBy({ left, behavior: "smooth" });
    return (
        <div className="hidden items-center gap-2 md:flex">
            <button
                type="button"
                aria-label="Previous reviews"
                onClick={() => scrollBy(-340)}
                disabled={!canScrollPrevious}
                className={ARROW_CLASS}
            >
                <ChevronLeftIcon className="size-5" />
            </button>
            <button
                type="button"
                aria-label="Next reviews"
                onClick={() => scrollBy(340)}
                disabled={!canScrollNext}
                className={ARROW_CLASS}
            >
                <ChevronRightIcon className="size-5" />
            </button>
        </div>
    );
}

export function ReviewsReadMoreLink({
    providerId,
    className,
}: {
    providerId: string;
    className?: string;
}) {
    return (
        <Link
            to="/provider/$providerId/reviews"
            params={{ providerId }}
            className={cn(
                "mt-6 flex items-center justify-between text-doberman-black rounded-nested bg-true-black/[0.03] px-4 py-3.5 transition-colors duration-150 [@media(hover:hover)]:hover:bg-true-black/[0.06] motion-reduce:transition-none focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-labrador-yellow focus-visible:ring-offset-2",
                className,
            )}
        >
            <span className="text-label">Read more</span>
            <ChevronRightIcon className="size-5" />
        </Link>
    );
}
